var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedbackIconMobile = function SvgFeedbackIconMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#423DCF",
    clipPath: "url(#FeedbackIconMobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.664 10.54q.002.033.004.065c0 6.785-5.914 12.305-13.184 12.305h-3.74C9.31 27.052 13.536 30 18.516 30H29.12a.88.88 0 0 0 .598-1.524l-2.405-2.23A10.14 10.14 0 0 0 30 19.394c0-3.642-2.114-6.944-5.336-8.854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.282 19.629a.879.879 0 0 0 .597 1.523h10.605c6.3 0 11.426-4.73 11.426-10.547C22.91 4.79 17.784 0 11.484 0S0 4.79 0 10.606c0 2.513.947 4.893 2.686 6.793zM6.21 5.332h10.547a.878.878 0 1 1 0 1.758H6.21a.878.878 0 1 1 0-1.758m0 3.516h10.547a.878.878 0 1 1 0 1.757H6.21a.878.878 0 1 1 0-1.757m0 3.515h10.547a.878.878 0 1 1 0 1.758H6.21a.878.878 0 1 1 0-1.758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FeedbackIconMobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgFeedbackIconMobile;